module.exports = __webpack_public_path__ + "img/animacion-2d-3d_info.67bb9a40.jpg";